import { CnStep } from '@/components/cn-step';

export default CnStep;
